// extracted by mini-css-extract-plugin
export default {"errorScreen":"error-screen__errorScreen","primaryBtn":"error-screen__primaryBtn","secondaryBtn":"error-screen__secondaryBtn"};